import { STORES, getAll, put, remove } from './db';

// Sales made while offline are queued here (requestData exactly as it would
// have been POSTed to /api/v1/createOrder) and replayed in order once the
// connection is back — see syncService.js.
export async function enqueueOrder(requestData) {
    const record = {
        localId: `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        requestData,
        createdAt: new Date().toISOString(),
    };
    await put(STORES.PENDING_ORDERS, record);
    return record;
}

export function listPendingOrders() {
    return getAll(STORES.PENDING_ORDERS);
}

export function removePendingOrder(localId) {
    return remove(STORES.PENDING_ORDERS, localId);
}
